import Cookies from 'js-cookie'
import {mapState,mapActions,mapGetters} from 'vuex';

export default {
    computed: {
        //mapState can be used to quickly get values from the state
        ...mapState('cookiepopup',
            ['showPopup',
                'activeTheme',
                'consentItems',
                'consentPackage',
                'popupTitle',
                'simpleDescription']
        ),

        ...mapState([
                'settings',
                'translations'
            ],
        ),

        ...mapGetters('cookiepopup',
            ['allItemsActive']
        ),
    },

    methods: {
        togglePopup() {
            this.$store.commit('cookiepopup/togglePopup');
        },

        acceptCookie(type) {
            var self = this;

            //close popup
            this.$store.commit('cookiepopup/togglePopup');

            //get date for cookie
            let cookieDate = new Date();

            let consentPackage = {
                "Name": self.consentPackage[0].name,
                "Version": self.consentPackage[0].version,
                "Theme": self.activeTheme
            };

            let data = {};

            //if its an advanced popup, we want to keep track of extra data
            if(type === 'advanced') {
                _.each(this.allItemsActive, function(item, index) {
                    //get the names from the consented items
                    data[index] = { "Name": item.name };
                });

            }

            //set cookie
            Cookies.set('consent-v2-dismissed', {
                type: type,
                consentPackage: consentPackage,
                data: data,
                date: cookieDate
            }, {
                expires: 365
            });

            //reload
            location.reload();
        }
    }
}